














































import Vue from "vue";
import { AxiosResponse, AxiosError } from "axios";
export default Vue.extend({
  name: "Search",
  data() {
    return {
      query: null,
      hits: null,
      results: null,
      responseTime: null,
      showResults: false
    };
  },
  methods: {
    search() {
      this.showResults = false;

      const searchQuery = this.query;

      this.axios
        .get("/api/search", { params: { q: searchQuery } })
        .then((res: AxiosResponse) => {
          this.showResults = true;
          this.hits = res.data.hits;
          this.responseTime = res.data.time;
          this.results = res.data.results;
        })
        .catch((err: AxiosError) => {
          console.error(err);
        });
    }
  }
});
